import Vue from 'vue';
import VueGettext from 'vue-gettext';
import Storage from "@/utils/storage";
let defaultLanguage = 'en_EN'
let availableLanguages = {} 
Object.keys(currentTranslation).forEach(language => {
  if(language == 'en_EN'
    || language == 'fr_FR'
    || language == 'vi_VN'
  ) {
    availableLanguages[language] = language
  }
})
if(location.host.startsWith('localhost')) {
  const port = parseInt(location.host.split(':')[1])
  switch(port) {
    case 8768:
      defaultLanguage = 'fr_FR'; break;
    case 8769:
      defaultLanguage = 'vi_VN'; break;
    case 8770:
      defaultLanguage = 'de_DE'; break;
    case 8771:
      defaultLanguage = 'it_IT'; break;
    case 8772:
      defaultLanguage = 'en_EN'; break;
    case 8773:
      defaultLanguage = 'en_EN'; break;
    default:
      defaultLanguage = 'fr_FR'; break;
  }
} else if(location.host.startsWith('fr.') 
  || location.host.startsWith('www.fr.')
) {
  defaultLanguage = 'fr_FR'
} else if(location.host.startsWith('vn.') 
  || location.host.startsWith('www.vn.')
) {
  defaultLanguage = 'vi_VN'
} else if(location.host.startsWith('it.') 
  || location.host.startsWith('www.it.')
) {
  defaultLanguage = 'it_IT'
} else if(location.host.startsWith('de.') 
  || location.host.startsWith('www.de.')
) {
  defaultLanguage = 'de_DE'
}
let currentLanguage = Storage.get('currentLanguage')
if(currentLanguage) {
	if(currentLanguage.indexOf('-') !== -1) {
		Storage.set('currentLanguage', currentLanguage.replace('-', '_'))
		currentLanguage = currentLanguage.replace('-', '_')
	}
  defaultLanguage = currentLanguage
}
const forceEnglish = document.URL.match(/ln=en/)
if(forceEnglish) {
  defaultLanguage = 'en_EN';
  Storage.set('currentLanguage', 'en_EN')
}
Vue.use(VueGettext, {
  availableLanguages,
  defaultLanguage,
  translations: currentTranslation,
  silent: true
});

export default VueGettext;
